export const SMALL_MODAL_WIDTH = 560;
export const MODAL_WIDTH = 640;
export const MODAL_HEIGHT = 640;
export const LARGE_MODAL_WIDTH = 728;
export const LARGE_MODAL_HEIGHT = '80vh';

export const CONTENT_PAGE_WIDTH = 728;

export const FILE_SIZE_LIMIT_BYTES = 50 * 1024 * 1024; // 50MB.
export const FILE_OVERSIZE_ERROR_MESSAGE = 'File must be smaller than 50MB!';
// 5000ms (5s) refresh interval.
export const DEFAULT_REFRESH_INTERVAL = 5 * 1000;

export const COMMENT_AVATAR_SIZE = 32;
